import {Utilities} from '@shared/utilities/utilities.model';

export class AdministrationWorkingItemsModel {
	reRegistration: boolean;
	duplicateBooklet: boolean;
	rePunching: boolean;
	theftReturn: boolean;
	demolition: boolean;
	recallCampaign: boolean;
	adminOrdinaryMaintenance: boolean;
	adminExtraordinaryMaintenance: boolean;
	adminCraneMaintenance: boolean;
	deRequisition: boolean;

	constructor(model?: any) {
		if (!Utilities.isVoid (model)) {
			this.reRegistration = model.re_registration;
			this.duplicateBooklet = model.duplicate_booklet;
			this.rePunching = model.re_punching;
			this.theftReturn = model.theft_return;
			this.demolition = model.demolition;
			this.recallCampaign = model.recall_campaign;
			this.adminOrdinaryMaintenance = model.admin_ordinary_maintenance;
			this.adminExtraordinaryMaintenance = model.admin_extraordinary_maintenance;
			this.adminCraneMaintenance = model.admin_crane_maintenance;
			this.deRequisition = model.de_requisition;
		}
	}
}

export class AdministrationWorkingItemsRequestModel {
	re_registration: boolean;
	duplicate_booklet: boolean;
	re_punching: boolean;
	theft_return: boolean;
	demolition: boolean;
	recall_campaign: boolean;
	admin_ordinary_maintenance: boolean;
	admin_extraordinary_maintenance: boolean;
	admin_crane_maintenance: boolean;
	de_requisition: boolean;

	constructor(model?: any) {
		if (!Utilities.isVoid (model)) {
			this.re_registration = model.reRegistration;
			this.duplicate_booklet = model.duplicateBooklet;
			this.re_punching = model.rePunching;
			this.theft_return = model.theftReturn;
			this.demolition = model.demolition;
			this.recall_campaign = model.recallCampaign;
			this.admin_ordinary_maintenance = model.adminOrdinaryMaintenance;
			this.admin_extraordinary_maintenance = model.adminExtraordinaryMaintenance;
			this.admin_crane_maintenance = model.adminCraneMaintenance;
			this.de_requisition = model.deRequisition;
		}
	}
}
